const ContactUsUrl = '/contact-us';

export default ContactUsUrl;
